import { useEffect, useRef, useState } from "react";
import {
    GetASD,
    GroupByForeignKey,
    GroupByPropCheck,
    GroupByProps,
} from "../Actions/GetContainer";
import { EjercicioByRange } from "./EjercicioByRange";
import { Mes } from "./Mes";
import StorageIcon from "@mui/icons-material/Storage";
import CloseIcon from "@mui/icons-material/Close";
import FilterListIcon from "@mui/icons-material/FilterList";
import SortIcon from "@mui/icons-material/Sort";
import TuneIcon from "@mui/icons-material/Tune";
import { LoaderScreen } from "../../components/LoaderScreen";
import Swal from "sweetalert2";
import { Visualizacion } from "./Visualizacion";

export const FiltroVentas = ({
    children,
    onBoxChange,
    boxState,
    sucursales,
    BoxClick,
    titulo_filtro,
    titulo = "",
    subtitulo = "",
    mostraradr = true,
    mostrarsucursal = true,
    mostrardepartamento = true,
    mostrarvisualizacion = false,
    cargarfiltros = true,
}) => {
    const [stateError, setError] = useState("");

    const fechaActual = new Date();
    const ejercicioActual = fechaActual.getFullYear();
    const mesActual = fechaActual.getMonth() + 1;
    const storedState = JSON.parse(localStorage.getItem('dashboard_filtro')) || {};
    const [state, setstate] = useState({
        data: [],
        adr: [],
        sucursal: [],
        departamento: [],
        ejercicioinicio: storedState.ejercicio || ejercicioActual,
        periodoinicio: storedState.periodoinicio || "1",
        ejerciciofin: storedState.ejercicio || ejercicioActual,
        periodofin: storedState.periodofin || mesActual,
        tsucursal: "",
        tdeptos: "",
        visualizacion: "1",
    });
    const {
        data,
        adr,
        sucursal,
        departamento,
        ejercicioinicio,
        periodoinicio,
        ejerciciofin,
        periodofin,
        visualizacion
    } = state;
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });
    useEffect(() => {
        onClose();
        if (cargarfiltros)
            GetASD()
                .then((res) => {
                    setstate({
                        ...state,
                        data: res,
                    });
                    let sucursalesSeleccionadas = boxState?.pv?.sucursal?.length > 0
                        ? boxState.pv.sucursal
                        : sucursales.map(s => ({ idsucursal: s.idsucursal, sucursal: s.sucursal || s.nombreSucursal || "" }));

                    let departamentosSeleccionados = boxState?.pv?.departamento?.length > 0
                        ? boxState.pv.departamento
                        : sucursales
                            .reduce((acc, s) => {
                                s.departamentos?.forEach(dep => {
                                    if (!acc.some(d => d.iddepartamento === dep.iddepartamento)) {
                                        acc.push({ iddepartamento: dep.iddepartamento, departamento: dep.departamento || dep.nombre || "" });
                                    }
                                });
                                return acc;
                            }, []);
                    onBoxChange("pv", {
                        adr: GroupByProps(res, ["idadr", "adr"]),
                        sucursal: sucursalesSeleccionadas,
                        departamento: departamentosSeleccionados,
                    });
                })
                .catch((err) => console.log(err));
    }, []);

    const accesosPermitidos = new Set(
        sucursales?.map(s => `${s.idsucursal}-${s.iddepartamento}`)
    );
    const idsSucursalPermitidas = [...new Set(sucursales?.map(s => String(s.idsucursal)))];

    const sucursalFiltrada = sucursal.filter(item => idsSucursalPermitidas.includes(item.idsucursal));

    const departamentosFiltrados = data?.filter(d => accesosPermitidos.has(`${d.idsucursal}-${d.iddepartamento}`))
        .reduce((acc, curr) => {
            if (!acc.some(dep => dep.iddepartamento === curr.iddepartamento)) {
                acc.push({ iddepartamento: curr.iddepartamento, departamento: curr.departamento });
            }
            return acc;
        }, []);

    const adrFiltrado = adr?.filter(itemAdr =>
        data.some(d => String(d.idadr) === String(itemAdr.idadr) && idsSucursalPermitidas.includes(String(d.idsucursal)))
    );

    useEffect(() => {
        var newadr = GroupByPropCheck(data, ["idadr", "adr"]);
        var newsucursal = GroupByPropCheck(data, ["idsucursal", "sucursal"], false);
        var newdepartamento = GroupByPropCheck(
            data,
            ["iddepartamento", "departamento"],
            false
        );
        setstate({
            ...state,
            adr: newadr,
            sucursal: newsucursal,
            departamento: newdepartamento,
        });
    }, [data]);
    const onChange = ({ target }) => {
        setstate({
            ...state,
            [target.name]: target.value,
        });
        onBoxChange(target.name, target.value);
    };
    const labelclick = ({ target }) => {
        target.parentNode.firstChild.click();
    };



    const selectedClick = ({ target }, index) => {
        switch (target.name) {
            case "chk-adr":
                var newarray = adr;
                newarray[index].checked = target.checked;

                var newarrarsucursal = [];
                var newarraydepartamento = [];
                var adrActive = [];
                newarray.forEach((item) => {
                    if (item.checked) {
                        adrActive = [...adrActive, { idadr: item.idadr, adr: item.adr }];
                        newarrarsucursal = newarrarsucursal.concat(
                            GroupByForeignKey(data, "idadr", item.idadr, [
                                "idsucursal",
                                "sucursal",
                            ])
                        );
                        newarraydepartamento = newarraydepartamento.concat(
                            GroupByForeignKey(data, "idadr", item.idadr, [
                                "iddepartamento",
                                "departamento",
                            ])
                        );
                    }
                });
                onBoxChange("pv", {
                    adr: adrActive,
                    sucursal: [],
                    departamento: [],
                });
                setstate({
                    ...state,
                    adr: newarray,
                    sucursal:
                        newarrarsucursal.length == 0
                            ? GroupByPropCheck(data, ["idsucursal", "sucursal"], false)
                            : GroupByPropCheck(
                                newarrarsucursal,
                                ["idsucursal", "sucursal"],
                                false
                            ),
                    departamento:
                        newarraydepartamento.length == 0
                            ? GroupByPropCheck(
                                data,
                                ["iddepartamento", "departamento"],
                                false
                            )
                            : GroupByPropCheck(
                                newarraydepartamento,
                                ["iddepartamento", "departamento"],
                                false
                            ),
                });
                break;
            case "chk-sucursal":
                var newarray = sucursalFiltrada;
                newarray[index].checked = target.checked;

                var newarraydepartamento = [];
                var sucursalactiva = [];
                newarray.forEach((item) => {
                    if (item.checked) {
                        sucursalactiva = [
                            ...sucursalactiva,
                            { idsucursal: item.idsucursal, sucursal: item.sucursal },
                        ];
                        newarraydepartamento = newarraydepartamento.concat(
                            GroupByForeignKey(data, "idsucursal", item.idsucursal, [
                                "iddepartamento",
                                "departamento",
                            ])
                        );
                    }
                });
                onBoxChange("pv", {
                    adr: boxState.pv.adr,
                    sucursal: sucursalactiva,
                    departamento: [],
                });
                setstate({
                    ...state,
                    sucursal: newarray,
                    departamento:
                        newarraydepartamento.length == 0
                            ? GroupByPropCheck(
                                data,
                                ["iddepartamento", "departamento"],
                                false
                            )
                            : GroupByPropCheck(
                                newarraydepartamento,
                                ["iddepartamento", "departamento"],
                                false
                            ),
                });
                break;
            default:
                var newarray = departamento;
                var departamentoactivo = [];
                newarray[index].checked = target.checked;

                newarray.forEach((item) => {
                    if (item.checked) {
                        departamentoactivo = [
                            ...departamentoactivo,
                            {
                                iddepartamento: item.iddepartamento,
                                departamento: item.departamento,
                            },
                        ];
                    }
                });
                onBoxChange("pv", {
                    adr: boxState.pv.adr,
                    sucursal: boxState.pv.sucursal,
                    departamento: departamentoactivo,
                });
                setstate({
                    ...state,
                    departamento: newarray,
                });
                break;
        }
    };
    const onClick = () => {
        const element = document.getElementById("box-structure-bussiness-filtros-2");
        if (element != undefined && element != null) {
            element.style.display = "flex";
        }
    };
    const onClose = () => {
        const element = document.getElementById("box-structure-bussiness-filtros-2");
        if (element != undefined && element != null) {
            element.style.display = "none";
        }
        closeConsulta();
    };
    const closeConsulta = () => { };
    const consultar = () => {
        setLoader({ ...loader, mostrar: true });
        BoxClick()
            .then(() => {
                var tituloSucursal = "";
                var tituloDeptos = "";
                if (boxState.pv.sucursal != undefined && boxState.pv.sucursal != null) {
                    if (boxState.pv.sucursal.length == 0) {
                        if (boxState.pv.adr.length == 1) {
                            tituloSucursal = `Region ${boxState.pv.adr[0].adr},`;
                        } else {
                            tituloSucursal = `TODO EL GRUPO,`;
                        }
                    } else {
                        boxState.pv.sucursal.forEach((item) => {
                            tituloSucursal += `${item.idsucursal}-${item.sucursal}${","} `;
                        });
                    }
                }

                if (
                    boxState.pv.departamento != undefined &&
                    boxState.pv.departamento != null
                ) {
                    if (boxState.pv.departamento.length == 0) {
                        tituloDeptos = "TODOS LOS DEPARTAMENTOS,";
                    } else {
                        boxState.pv.departamento.forEach((item) => {
                            tituloDeptos += `${item.iddepartamento}-${item.departamento
                                }${","} `;
                        });
                    }
                }
                setstate({
                    ...state,
                    tsucursal: tituloSucursal.substr(0, tituloSucursal.length - 1),
                    tdeptos: tituloDeptos.substr(0, tituloDeptos.length - 1),
                });
                setLoader({ ...loader, mostrar: false });
                onClose();
            })
            .catch((err) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("ANALISIS FINANCIERO", JSON.stringify(err), "error");
            });
    };
    const GetChildren = (key) => {
        if (children === undefined || children === null) return <></>;
        if (Array.isArray(children)) {
            var result = children.filter((x) => x.key === key);
            if (result !== undefined && result !== null && result.length > 0) {
                return result[0];
            }
        }
        if (children.key === key) return children;

        return <></>;
    };

    const capitalizeWords = (str) => {
        return str ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase()) : "";
    };
    return (
        <>
            {/* <LoaderScreen loader={loader} /> */}
            <div className="encabezado-reports-filtros-2">
                <div>
                    <div className="filtro-titulo">
                        <button className="boton-box-structure" onClick={onClick}>
                            <TuneIcon />
                            Filtro
                        </button>
                        <header>
                            <div className="titulo">{titulo}</div>
                            <div className="sub-titulo">{subtitulo}</div>
                        </header>
                    </div>
                    {/* {cargarfiltros === false || mostrarsucursal === false ? (
            <div></div>
          ) //: (
            <div
              className="contenido-cargado"
              //style={{ textTransform: "uppercase" }}
            >
              <label>Sucursal: </label>[{state.tsucursal}]
            </div>
          )} */}
                    {/* {cargarfiltros === false || mostrardepartamento === false ? (
            <div></div>
          ) : (
            <div
              className="contenido-cargado"
              //style={{ textTransform: "uppercase" }}
            >
              <label> Depto:</label> [{state.tdeptos}]
            </div>
          )} */}
                </div>
                {GetChildren("box-actions")}
            </div>
            <div
                id="box-structure-bussiness-filtros-2"
                key="box-structure-bussiness-filtros-2"
            >
                <div className="filtro-soy-el-titulo">
                    <div className="filtro-soy-el-titulo-header">
                        {titulo_filtro}
                        <span className="filtro-soy-span-close" onClick={onClose}>
                            X
                        </span>
                    </div>
                    <div className="filtro-soy-el-titulo-line">
                        <div className="filtro-soy-el-titulo-line-bl"></div>
                        <div className="filtro-soy-el-titulo-line-circle"></div>
                        <div className="filtro-soy-el-titulo-line-br"></div>
                    </div>
                </div>
                <div className="box-action-container-filtros">
                    <div className="filtro-tiempo-tipo">
                        <div className="filtro-group">
                            <label>Ejercicio Inicio</label>
                            <EjercicioByRange
                                name="ejercicioinicio"
                                value={ejercicioinicio}
                                onChange={onChange}
                            />
                        </div>
                        <div className="filtro-group">
                            <label>Periodo Inicio</label>
                            <Mes
                                name="periodoinicio"
                                value={periodoinicio}
                                onChange={onChange}
                            />
                        </div>
                        <div className="filtro-group">
                            <label>Ejercicio Fin</label>
                            <EjercicioByRange
                                name="ejerciciofin"
                                value={ejerciciofin}
                                onChange={onChange}
                            />
                        </div>
                        <div className="filtro-group">
                            <label>Periodo Fin</label>
                            <Mes name="periodofin" value={periodofin} onChange={onChange} />
                        </div>
                        {cargarfiltros === false || mostrarvisualizacion === false ? (
                            <div></div>
                        ) : (
                            <div className="filtro-group">
                                <label>Visualizacion</label>
                                <Visualizacion name="visualizacion" value={visualizacion} onChange={onChange} />
                            </div>
                        )}
                        {GetChildren("box-filtro")}

                        <div className="box-filtros-container-buttons">
                            {/* <button className="button-cancel" onClick={onClose}>
                Cancelar
              </button> */}
                            <button className="button-accept" onClick={consultar}>
                                <FilterListIcon /> Cargar
                            </button>
                        </div>
                    </div>
                    {cargarfiltros === false || mostraradr === false ? (
                        <div></div>
                    ) : (
                        <div className="filtro-adr">
                            <div className="title title-adr">Región</div>
                            {adrFiltrado?.map((item, index) => (
                                <div key={`${item}-${index}`} className="chk-groups">
                                    <input
                                        type="checkbox"
                                        name="chk-adr"
                                        onChange={(e) => selectedClick(e, index)}
                                        checked={item.checked}
                                        value={item.idadr}
                                    />
                                    <label>{capitalizeWords(item.adr)}</label>
                                </div>
                            ))}
                        </div>
                    )}
                    {cargarfiltros === false || mostrarsucursal === false ? (
                        <div></div>
                    ) : (
                        <div className="filtro-sucursal">
                            <div className="title">Sucursal</div>
                            {sucursalFiltrada?.map((item, index) => (
                                <div key={`${item}-${index}`} className="chk-groups">
                                    <input
                                        type="checkbox"
                                        name="chk-sucursal"
                                        className="my-checkbox"
                                        onChange={(e) => selectedClick(e, index)}
                                        checked={item.checked}
                                        value={item.idsucursal}
                                    />
                                    <label onClick={labelclick}>{capitalizeWords(item.sucursal)}</label>
                                </div>
                            ))}
                        </div>
                    )}
                    {cargarfiltros === false || mostrardepartamento === false ? (
                        <div></div>
                    ) : (
                        <div className="filtro-departamento">
                            <div className="title">Departamento</div>
                            {departamentosFiltrados?.map((item, index) => (
                                <div key={`${item}-${index}`} className="chk-groups">
                                    <input
                                        type="checkbox"
                                        name="chk-departamento"
                                        onChange={(e) => selectedClick(e, index)}
                                        checked={item.checked}
                                        value={item.iddepartamento}
                                    />
                                    <label>{capitalizeWords(item.departamento)}</label>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};
